import React from 'react';

import {
  createErrorDescriptor,
  FetchStatus,
  isFetchStatusFailed,
} from '@neptune/shared/common-domain';

import { HttpErrorPageContainer } from './HttpErrorPageContainer';

type UseNotFoundInput = {
  fetchStatus: FetchStatus;
  error: unknown;
};

type UseNotFoundValue = React.ComponentType | undefined;

export function useNotFound({ fetchStatus, error }: UseNotFoundInput): UseNotFoundValue {
  if (!isFetchStatusFailed(fetchStatus)) {
    return;
  }

  const errorDescriptor = createErrorDescriptor(error);

  if (errorDescriptor.code === 404) {
    return function NotFoundHttpErrorPageContainer() {
      return React.createElement(HttpErrorPageContainer, { error: errorDescriptor });
    };
  }
}
